export default __webpack_public_path__ + "static/media/Source2_Candidate_upload_Rich_File_LOCAL.48f64592.xlsx";